import { render, staticRenderFns } from "./DiscountCodesCreate.vue?vue&type=template&id=3f1c168e"
import script from "./DiscountCodesCreate.vue?vue&type=script&lang=ts"
export * from "./DiscountCodesCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports